<template>
    <div class="t-tiles">
        <OHeader :view="view"/>
        <OMainFrame :view="view"/>
        <OFooter :view="view" />
        <OKeyboardStandard
            v-if="isKeyboard"
            class="tiles-keyboard"
        />
    </div>
</template>

<script>
import OHeader from '../../../organisms/o-header/o-header';
import OFooter from '../../../organisms/o-footer/o-footer';
import OMainFrame from '../../../organisms/o-main-frame';
import OKeyboardStandard from '../../../organisms/o-keyboard-standard';

import { EVENTS } from "../../../../utils/constants/bus-events-constants";

export default {
    name: 'TTiles',
    components: {
        OHeader,
        OFooter,
        OMainFrame,
        OKeyboardStandard
    },
    data() {
        return {
            view: this.$route.params.path,
            isKeyboard: false
        }
    },
    mounted() {
        this.initListeners();
    },
    deactivated() {
        this.isKeyboard = false;
        this.$bus.$emit(EVENTS.KEYBOARD_STANDARD.CLOSE_KEYBOARD);
    },
    beforeDestroy() {
        this.removeListeners();
    },
    methods: {
        initListeners() {
            this.$bus.$on(EVENTS.KEYBOARD_STANDARD.INIT_KEYBOARD, this.initKeyboard);
            this.$bus.$on(EVENTS.KEYBOARD_STANDARD.CLOSE_KEYBOARD, this.closeKeyboard);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.KEYBOARD_STANDARD.INIT_KEYBOARD, this.initKeyboard);
            this.$bus.$off(EVENTS.KEYBOARD_STANDARD.CLOSE_KEYBOARD, this.closeKeyboard);
        },
        initKeyboard() {
            this.isKeyboard = true;
        },
        closeKeyboard() {
            this.isKeyboard = false;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
